import { render } from "./EditTaskReferenceModal.vue?vue&type=template&id=1b831642&scoped=true"
import script from "./EditTaskReferenceModal.vue?vue&type=script&lang=js"
export * from "./EditTaskReferenceModal.vue?vue&type=script&lang=js"

import "./EditTaskReferenceModal.vue?vue&type=style&index=0&id=1b831642&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b831642"]])

export default __exports__